import { Link } from 'react-router-dom'
import { useAsync } from '../hooks/useAsync'
import { fetchHomepageUpdate } from '../services/league'
import { Notice, formatPostedDate } from './ui'
import UpdateBody from './UpdateBody'
import './HomeUpdate.css'

/**
 * The newest league update, sat under the hero actions.
 *
 * @remarks
 * Renders nothing when the homepage slot is empty, so a taken-down post does
 * not leave a blank card. The archive is always a click away from a live one.
 */
export default function HomeUpdate() {
  const loaded = useAsync(fetchHomepageUpdate, [])

  if (loaded.loading) {
    return null
  }
  if (!loaded.data) {
    if (loaded.error) {
      return <Notice tone="error">{loaded.error}</Notice>
    }
    return null
  }

  const update = loaded.data

  return (
    <article className="home-update">
      <div className="home-update__header">
        <span className="eyebrow">League update</span>
        <time className="home-update__date muted" dateTime={update.editedAt ?? update.postedAt}>
          {formatPostedDate(update.postedAt, update.editedAt)}
        </time>
      </div>
      <h2 className="home-update__title">{update.title}</h2>
      <div className="home-update__body">
        <UpdateBody text={update.body} />
      </div>
      <Link className="home-update__archive" to="/updates">
        All updates
      </Link>
    </article>
  )
}
